import { Country } from "../../countries"
import { CurrencyCode } from "../../currencies"

export enum CardType {
  BANK = "bank",
  CHARITIES = "charities",
  PAYPAL = "paypal",
  VISA = "visa",
  VENMO = "venmo",
  MERCHANT_CARDS = "merchant_cards",
  INSTANT_DEBIT_TRANSFERS = "instant_debit_transfers",
}

interface ResponseCatalogItem {
  id: string
  name: string
  category: CardType
  countries: string[]
  currency_codes: CurrencyCode[]
  logo_image_path?: string
  card_image_path?: string
}

export interface ResponseCatalog {
  currencies: CurrencyCode[]
  catalog: ResponseCatalogItem[]
}

export type CatalogItem = Pick<
  ResponseCatalogItem,
  "id" | "name" | "category"
> & {
  currencyCodes: CurrencyCode[]
  cardImagePath: ResponseCatalogItem["card_image_path"]
  logoImagePath: ResponseCatalogItem["logo_image_path"]
  countryCodes: ResponseCatalogItem["countries"]
  countries: Country[]
}

export type GetCatalog = {
  catalog: CatalogItem[]
  currencies: CurrencyCode[]
}
